import React from "react";

const ErrorMessage = () => {

    return (
        <div className="error">
            <p>Sorry, but we don't seem to have any recipes for this request at the moment</p>
        </div>
    );
};

export default ErrorMessage;